// oxlint-disable actual/no-untranslated-strings -- componente del solo
// ambiente dimostrativo italiano: i testi sono deliberatamente letterali,
// come quelli della visita guidata (public/tour-contabile.js).
import React, { useState } from 'react';

import { Button } from '@actual-app/components/button';
import { useResponsive } from '@actual-app/components/hooks/useResponsive';
import { Text } from '@actual-app/components/text';
import { Tooltip } from '@actual-app/components/tooltip';
import { View } from '@actual-app/components/view';

import { useMetadataPref } from '#hooks/useMetadataPref';
import { chipDemoChiusa, chiudiChipDemo, NOME_BUDGET_DEMO } from '#util/demo';

/**
 * Contabile (fork): chip "Demo" discreta, visibile finché è aperto il budget
 * dimostrativo. Chiudibile per la sessione (torna alla prossima). Due punti
 * di montaggio: dentro la Titlebar sul desktop, flottante sul mobile — il
 * componente è lo stesso, cambia solo `flottante`.
 */
type DemoChipProps = {
  /** Montaggio flottante per il layout stretto (la Titlebar lì non c'è). */
  flottante?: boolean;
};

export function DemoChip({ flottante = false }: DemoChipProps) {
  const [budgetName] = useMetadataPref('budgetName');
  const { isNarrowWidth } = useResponsive();
  const [chiusa, setChiusa] = useState(() => chipDemoChiusa());

  if (budgetName !== NOME_BUDGET_DEMO || chiusa) return null;
  // L'istanza flottante copre solo il layout stretto; sul largo la chip
  // sta nella Titlebar.
  if (flottante && !isNarrowWidth) return null;

  const chip = (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
        backgroundColor: '#D1FAE5',
        color: '#065F46',
        borderRadius: 999,
        padding: '2px 2px 2px 10px',
        boxShadow: flottante ? '0 2px 8px rgba(11, 15, 20, 0.18)' : 'none',
      }}
    >
      <Text style={{ fontSize: 12, fontWeight: 700, letterSpacing: 0.3 }}>
        Demo
      </Text>
      <Button
        variant="bare"
        aria-label="Nascondi per questa sessione"
        onPress={() => {
          chiudiChipDemo();
          setChiusa(true);
        }}
        style={{
          color: '#065F46',
          borderRadius: 999,
          padding: '0 6px',
          minHeight: 20,
          fontSize: 13,
          lineHeight: 1,
        }}
      >
        ×
      </Button>
    </View>
  );

  if (flottante) {
    return (
      <View
        style={{
          position: 'fixed',
          // Sopra le linguette di navigazione mobile.
          bottom: 'calc(80px + env(safe-area-inset-bottom))',
          right: 12,
          zIndex: 900,
        }}
        title="Budget dimostrativo"
      >
        {chip}
      </View>
    );
  }

  return (
    <Tooltip placement="bottom end" content="Budget dimostrativo">
      {chip}
    </Tooltip>
  );
}
